import Vue from 'vue'
import Router from 'vue-router'
// 一级路由
// import Home from '@/view/index'
const Home = () => import('@/view/index')
// const YltHome = () => import('@/view/yltindex')
// 售后
const CustomService = () => import('@/view/customService')
const CustomOrder = () => import('@/view/customOrder')
// 订单详情
const OrderDetail = () => import('@/view/orderDetail')
// 物流信息
const LogisticsInfo = () => import('@/view/logisticsInfo')
// import OnLine from '@/view/onLine'
const OnLine = () => import('@/view/onLine')

const OnLine_copy = () => import('@/view/onLine_copy')
// import ProductDes from '@/view/productDescrition'
const ProductDes = () => import('@/view/productDescrition')

// import CommonQuestion from '@/view/commonQuestion'
const CommonQuestion = () => import('@/view/commonQuestion')

// import AboutUs from '@/view/aboutUs'
const AboutUs = () => import('@/view/aboutUs')

// import OnLineHandle from '@/view/onLineHandle'
const OnLineHandle = () => import('@/view/onLineHandle')
// import NowHandle from '@/view/NowHandle'
const onLineHandle_truck = () => import('@/view/onLineHandle_truck')
// import NowHandle_carOwnerInfo from '../view/NowHandle_carOwnerInfo'
const NowHandle_carOwnerInfo = () => import('@/view/NowHandle_carOwnerInfo')
const NowHandle_carOwnerInfo_reload = () => import('../view/NowHandle_carOwnerInfo_reload')
// import NowHandle_carInfo from '../view/NowHandle_carInfo'
const NowHandle_carInfo = () => import('@/view/NowHandle_carInfo')
const NowHandle_carInfo_reload = () => import('../view/NowHandle_carInfo_reload')
// import NowHandle_receiveAddress from '../view/NowHandle_receiveAddress'
const NowHandle_receiveAddress = () => import('@/view/NowHandle_receiveAddress')
const NowHandle_receiveAddress_reload = () => import('../view/NowHandle_receiveAddress_reload')
// import ConfirmOrder from '@/view/confirmOrder'
const ConfirmOrder = () => import('@/view/confirmOrder')

const ConfirmOrder_reload = () => import('@/view/confirmOrder_reload')

// import ConfirmPay from '@/view/confirmPay'
const ConfirmPay = () => import('@/view/confirmPay')

// import SetOutGoods from '@/view/setoutGoods'
const SetOutGoods = () => import('@/view/setoutGoods')

// import CheckGoods from '@/view/checkGoods'
const CheckGoods = () => import('@/view/checkGoods')

// import ConfirmReceive from '@/view/confirmReceive'
const ConfirmReceive = () => import('@/view/confirmReceive')

// import SearchBill from '@/view/searchBill'
// 旧的查询账单
// const SearchBill = () => import('@/view/searchBill')
// 新的查询账单
const SearchAccount = () => import('../view/searchAccount')

const AccountDetailInfo = () => import('../view/accountDetailInfo')
// import SearchOrder from '@/view/seachOrder'
const SearchOrder = () => import('@/view/seachOrder')

// import OrderDetailInfo from '@/view/orderDetailInfo'
const OrderDetailInfo = () => import('@/view/orderDetailInfo')

// import ErrorPage from '@/view/errorPage'
const ErrorPage = () => import('@/view/errorPage')

// import CheckOrderDetailInfo from '@/view/checkOrderDetailInfo'
const CheckOrderDetailInfo = () => import('@/view/checkOrderDetailInfo')

// import PaySuccess from '../view/paySuccess'
const PaySuccess = () => import('@/view/paySuccess')
const SignSuccess = () => import('@/view/signSuccess')
const UserKnow = () => import('../view/userKnow')
// 动态
const Dynamic = () => import('@/view/dynamic')
// 二级路由
// import QuestionList from '@/view/commonQuestion/questionList'
const QuestionList = () => import('@/view/commonQuestion/questionList')

// import QuestionDetailInfo from '@/view/commonQuestion/questionItem'
const QuestionDetailInfo = () => import('@/view/commonQuestion/questionItem')
const GoodsDetail = () => import('@/view/goodsDetail')
const CreateOrder = () => import('../view/cargoPassCard/createOrder/createOrder')
const UploadDoc = () => import('../view/cargoPassCard/uploadDoc/uploadDoc')
const UploadVehicle = () => import('../view/uploadVehicle/uploadVehicle')
const PayPostage = () => import('../view/payPostage')
const NowHandle_carInfos = () => import('../view/cargoPassCard/NowHandle_carInfos')
const UploadVehicles = () => import('../view/cargoPassCard/uploadVehicles/uploadVehicle')
const PayPostages = () => import('../view/cargoPassCard/payPostages')
// const danpin = () => import('@/view/tworouter/danpin')
// const jiluyi = () => import('@/view/tworouter/jiluyi')
// const zuhe = () => import('@/view/tworouter/zuhe')


Vue.use(Router)


const vueRouter = new Router({
  // mode: 'history',
  routes: [
    {path: '/', redirect: '/index'},
    {path: '/index', name: 'Home', component: Home,meta:{keepAlive:false}},
    // {path: '/yltindex', name: 'YltHome', component: YltHome},
    {path: '/onLine', name: 'OnLine', component: OnLine},
    {path: '/dynamic', name: 'Dynamic', component: Dynamic},
    {path: '/onLine_copy', name: 'OnLine_copy', component: OnLine_copy},
    {path: '/productDescription', name: 'ProductDes', component: ProductDes},
    {path: '/commonQuestion', name: 'CommonQuestion', component: CommonQuestion,children: [
      // {path: '/commonQuestion', redirect: '/commonQuestion/questionList'},
      // {path: '/commonQuestion/questionList', name: 'QuestionList', component: QuestionList},
      {path: '/commonQuestion/questionDetailInfo', name: 'QuestionDetailInfo', component: QuestionDetailInfo}
    ]},
    {path: '/aboutUs', name: 'AboutUs', component: AboutUs},
    {path: '/userKnow', name: 'UserKnow', component: UserKnow},
    // ETC办理
    {path: '/onLineHandle', name: 'OnLineHandle', component: OnLineHandle,children:[
      // {path:'danpin',name:'danpin',component:danpin},
      // {path:'jiluyi',name:'jiluyi',component:jiluyi},
      // {path:'zuhe',name:'zuhe',component:zuhe},
      // {path:'/onLineHandle',redirect:'danpin'},
    ]},
    {path: '/onLineHandle_truck', name: 'onLineHandle_truck', component: onLineHandle_truck,children:[
      // {path:'danpin',name:'danpin',component:danpin},
      // {path:'jiluyi',name:'jiluyi',component:jiluyi},
      // {path:'zuhe',name:'zuhe',component:zuhe},
      // {path:'/onLineHandle',redirect:'danpin'},
    ]},
    // 填写资料
    {path: '/nowHandle_carOwnerInfo', name: 'NowHandle_carOwnerInfo', component: NowHandle_carOwnerInfo,
      // meta:{keepAlive:true}
  },
    {path: '/nowHandle_carOwnerInfo_reload', name: 'NowHandle_carOwnerInfo_reload', component: NowHandle_carOwnerInfo_reload,
    // meta:{keepAlive:true}
  },
   //上传证件
    {path: '/nowHandle_carInfo', name: 'NowHandle_carInfo', component: NowHandle_carInfo,
    // meta:{keepAlive:true}
  },
    {path: '/nowHandle_carInfo_reload', name: 'NowHandle_carInfo_reload', component: NowHandle_carInfo_reload,
    // meta:{keepAlive:true}
  },
    // 签约绑定
    {path: '/nowHandle_receiveAddress', name: 'NowHandle_receiveAddress', component: NowHandle_receiveAddress,
    // meta:{keepAlive:true}
      
  },
    {path: '/nowHandle_receiveAddress_reload', name: 'NowHandle_receiveAddress_reload', component: NowHandle_receiveAddress_reload},
    
    {path: '/confirmOrder', name: 'ConfirmOrder', component: ConfirmOrder,meta:{keepAlive:false}},
       // 提交订单 微信
       {path: '/confirmOrder_reload', name: 'ConfirmOrder_reload', component: ConfirmOrder_reload,meta:{keepAlive:true}},
    // 提交订单
    {path: '/confirmPay', name: 'ConfirmPay', component: ConfirmPay},
    {path: '/setOutGoods', name: 'SetOutGoods', component: SetOutGoods},
    {path: '/checkGoods', name: 'CheckGoods', component: CheckGoods},
    {path: '/confirmReceive', name: 'ConfirmReceive', component: ConfirmReceive},
    // 旧的查询账单
    // {path: '/searchBill', name: 'SearchBill', component: SearchBill},
    {path: '/searchAccount', name: 'SearchAccount', component: SearchAccount},
    {path: '/accountDetailInfo', name: 'AccountDetailInfo', component: AccountDetailInfo},
    // 订单查询
    {path: '/searchOrder', name: 'SearchOrder', component: SearchOrder},
    // 订单列表
    {path: '/orderDetailInfo', name: 'OrderDetailInfo', component: OrderDetailInfo,
    // meta:{keepAlive:true}
  },
    {path: '/checkOrderDetailInfo', name: 'CheckOrderDetailInfo', component: CheckOrderDetailInfo},
    {path: '/errorPage', name: 'ErrorPage', component: ErrorPage},
    {path: '/paySuccess', name: 'PaySuccess', component: PaySuccess},
  
    // 售后订单
    {path: '/customService', name: 'CustomService', component: CustomService},
    {path: '/customOrder', name: 'CustomOrder', component: CustomOrder},
    // 订单详情
    {path: '/orderDetail', name: 'OrderDetail', component: OrderDetail},
    //物流信息
    {path: '/logisticsInfo', name: 'LogisticsInfo', component: LogisticsInfo},
        //物流信息
    {path: '/goodsDetail', name: 'GoodsDetail', component: GoodsDetail},
    {path:'/cargoPassCard/createOrder',name:'CreateOrder',component:CreateOrder},
    {path:'/cargoPassCard/uploadDoc',name:'UploadDoc',component:UploadDoc},
    {path:'/cargoPassCard/NowHandle_carInfos',name:'NowHandle_carInfos',component:NowHandle_carInfos},
    {path:'/cargoPassCard/payPostages',name:'PayPostages',component:PayPostages},
    {path:'/cargoPassCard/uploadVehicles',name:'UploadVehicles',component:UploadVehicles},
    {path: '/signSuccess', name: 'SignSuccess', component:SignSuccess},
    {path: '/uploadVehicle', name: 'UploadVehicle', component:UploadVehicle},
    {path: '/payPostage', name: 'PayPostage', component:PayPostage}
  ]
})
vueRouter.afterEach((to,from,next) => {
  console.log(to)
  console.log(from)
    window.scrollTo(0, 0)
})

export default vueRouter;



// WEBPACK FOOTER //
// ./src/router/index.js